"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientType = void 0;
var helper_1 = require("../../core/helper");
var ua_factory_1 = __importDefault(require("./ua/ua-factory"));
/**
   * 使用productName的定义
   *
   * 【金山文档】 金山文档AI功能标识汇总
   https://kdocs.cn/l/ckyUqu7IQQWU
   *
   *   pc	        金山文档PC客户端
   *   mac	    金山文档mac客户端
   *   ios	    金山文档iOS客户端
   *   android	金山文档安卓客户端
   *   iospad	    金山文档iPad客户端
   *   andpad	    金山文档安卓Pad客户端
   *   qqmp	    金山文档QQ小程序
   *   wxmp	    金山文档微信小程序
   *   wpspc	    WPS PC客户端
   *   wpsmac	    WPS mac客户端
   *   wpsand	    WPS安卓客户端
   *   wpsios	    WPS iOS客户端
   *   wpspadios	WPS iPad客户端
   *   wpspadand	WPS 安卓Pad客户端
   *   webm       web 移动端
   *   web	    web pc端（含兜底未细分）
   */
var getClientType = function () {
    var isWpsOfficeIOS = ua_factory_1.default.isWpsOfficeIOS, isWpsOfficeAndroid = ua_factory_1.default.isWpsOfficeAndroid, isWps2019 = ua_factory_1.default.isWps2019, isMacOs = ua_factory_1.default.isMacOs, isPad = ua_factory_1.default.isPad, isPcKdocsClient = ua_factory_1.default.isPcKdocsClient, isMobileWpsClient = ua_factory_1.default.isMobileWpsClient, isIos = ua_factory_1.default.isIos, isInWxMiniProgram = ua_factory_1.default.isInWxMiniProgram, isInQQMiniProgram = ua_factory_1.default.isInQQMiniProgram, isMobile = ua_factory_1.default.isMobile;
    // 金山文档PC客户端
    if (isPcKdocsClient) {
        return isMacOs ? 'mac' : 'pc';
    }
    // 金山文档移动端
    if (isMobileWpsClient) {
        if (isPad) {
            return isIos ? 'iospad' : 'andpad';
        }
        return isIos ? 'ios' : 'android';
    }
    // wps ios客户端
    if (isWpsOfficeIOS) {
        return isPad ? 'wpspadios' : 'wpsios';
    }
    // wps 安卓客户端
    if (isWpsOfficeAndroid) {
        return isPad ? 'wpspadand' : 'wpsand';
    }
    // wps pc端
    if (isWps2019) {
        // wps mac pc端
        return isMacOs ? 'wpsmac' : 'wpspc';
    }
    // 微信小程序
    if (isInWxMiniProgram) {
        return 'wxmp';
    }
    // qq小程序
    if (isInQQMiniProgram) {
        return 'qqmp';
    }
    return isMobile ? 'webm' : 'web'; // 兜底认为是pc端网页版
};
exports.getClientType = getClientType;
var getWpsAppInfo = function () {
    var _a;
    if (window.Extention) {
        return (0, helper_1.transformResult)((_a = window.Extention) === null || _a === void 0 ? void 0 : _a.Base.WpsOffice.getAppInfo());
    }
    else {
        console.warn('window.Extention不存在');
        return {};
    }
};
var base = __assign(__assign({ getClientType: exports.getClientType }, ua_factory_1.default), { getWpsAppInfo: getWpsAppInfo });
exports.default = base;
